// Light and clean entrypoint for the premium rebranded guest experiences (Landing & Checkout)
// Completely free from legacy Bootstrap/Appwork style injections.

import "@hotwired/turbo-rails"
import mrujs from "mrujs";
import { JsErb } from "mrujs/plugins"

mrujs.start({
  plugins: [
    JsErb()
  ]
})

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import I18n from 'i18n-js'
window.I18n = I18n

import toastr from 'toastr';
window.toastr = toastr

// Import custom checkout payment scripts (retaining functional compatibility)
import "../source/card-form"
import "../source/payment"

document.addEventListener("turbo:load", () => {
  const body = document.body;
  if (body && body.getAttribute('data-locale')) {
    window.I18n.locale = body.getAttribute('data-locale');
  }

  // Intersection Observer for Scroll-Driven Reveal Animations on Landing
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!window.IntersectionObserver) {
      // Fallback for older browsers or disabled JS states
      reveals.forEach(el => el.classList.add('active'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.05,
        rootMargin: "0px 0px -50px 0px"
      });

      reveals.forEach(el => observer.observe(el));
    }
  }

  // Parallax Background Movement for Hero Section on Landing
  const hero = document.querySelector('.hero-parallax');
  if (hero) {
    window.addEventListener('scroll', () => {
      const scrollY = window.scrollY;
      hero.style.backgroundPositionY = `calc(50% + (${scrollY * 0.15}px))`;
    });
  }
});
